import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { Services } from '@/infra/services';
import { type ItemId } from '@/infra/services/catalog/model';
import { type Response } from '@/infra/services/catalog/review/get-summary';
import { TWO_MINUTES_IN_MILISECONDS } from '@/utils/constants/time';

type QueryOptions = Omit<
  UseQueryOptions<Response, Error, Response>,
  'queryKey' | 'queryFn'
>;

const useSummary = (itemId: ItemId, options?: QueryOptions) => {
  const result = useQuery<Response, Error, Response>({
    queryKey: ['get-summary', itemId],
    queryFn: () => Services.Catalog.Review.getSummary({ itemId }),
    staleTime: TWO_MINUTES_IN_MILISECONDS,
    ...options,
  });

  return result;
};

export default useSummary;
